<cll-dialog-layout>
    <cll-dialog-header>
        <cll-icon cllDialogIcon>mark_email_unread</cll-icon>
        <cll-dialog-title>
            Mark messages as unread
        </cll-dialog-title>
        <cll-dialog-subtitle>{{messages.ids.length}} messages selected</cll-dialog-subtitle>

    </cll-dialog-header>
    <div class="dialog-container">
        <div class="dialog-detail">
            <span>Are you sure you want to mark these messages as unread? They will show as new and may trigger notifications.</span>
        </div>
    </div>
    <span class="dialog-divider"></span>
    <cll-dialog-footer>

        @if (unReadMessagesRequest.error(); as error) {
            <app-error-panel [error]="error" />
        }

        <button cll-button
                colour="variant"
                cllDialogClose>
            Cancel
        </button>
        <button cll-filled-button
                colour="secondary"
                (click)="unRead()">
            Confirm
        </button>
    </cll-dialog-footer>
</cll-dialog-layout>
